export const VENDORS_ACTIONS = {
    SET_VENDOR: 'SET_VENDOR',
    SET_VENDORS: 'SET_VENDORS',
    SET_VENDOR_OPTIONS: 'SET_VENDOR_OPTIONS',
    SET_VENDORS_PAGINATED: 'SET_VENDORS_PAGINATED',
    SET_VENDORS_META: 'SET_VENDORS_META',
    SET_STATUS: 'SET_VENDORS_STATUS',
    SET_ERRORS: 'SET_VENDORS_ERRORS',
    CLEAR_ERRORS: 'CLEAR_VENDORS_ERRORS'
};
export const initialVendorsState = {
    status: 'idle',
    errors: [],
    data: [],
    options: [],
    currentVendor: null,
    pageCount: 0,
    rowCount: 0
};
